var map = {
	"./br/PT/S1/bg53.png": 48088,
	"./br/PT/bg53.png": 98531,
	"./in/EN/S1/bg53.png": 14501,
	"./ph/EN/S1/bg53.png": 69373,
	"./ph/EN/bg53.png": 87727,
	"./vn/VI/S1/bg53.png": 93160
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 48480;